module.exports = __webpack_public_path__ + "img/GH-kyujin-top-h-pa-2.99ab6919.webp";